module.exports = __webpack_public_path__ + "h5/img/404.189d060f.png";